import type { Dispatch, PropsWithChildren, SetStateAction} from 'react'
import { createContext, useContext, useState } from 'react'

/* pouziva se na K2 pro rezim tisku, kde dojde kde zvyrazneni offer pro tisk */
export interface IPrintContext {
  printMode: boolean
  type: 'print' | 'email' | null
  setPrintMode: Dispatch<SetStateAction<boolean>>
  setType: Dispatch<SetStateAction<IPrintContext['type'] | null>>
}

const PrintModeContext = createContext<IPrintContext>({} as any)

export const PrintProvider = (props: PropsWithChildren) => {
  const { children } = props
  const [printMode, setPrintMode] = useState(false)
  const [type, setType] = useState<IPrintContext['type'] | null>(null)

  return (
    <PrintModeContext.Provider
      value={{
        printMode: printMode,
        type: type,
        setPrintMode: setPrintMode,
        setType: setType
      }}
    >
      {children}
    </PrintModeContext.Provider>
  )
}

export const usePrintContext = () => {
  return useContext(PrintModeContext)
}